import { FeatureNewsPosts } from "./feature/index"
import { RowNewsPosts } from "./row/index"
import { TaggedNewsPost } from "./tagged-post/index"
import "./index.scss"
import "./tagged-post/index.scss"

require.context("./static", true, /\.png|jpg|svg$/)

export { FeatureNewsPosts, RowNewsPosts, TaggedNewsPost }
